import { React, useState, useEffect } from "react";
import {
  Button,
  Form,
  Input,
  Select,
  Col,
  Row,
  Checkbox,
  Radio,
  Tooltip,
} from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import {
  HaberForm,
  RightDrawerContainer,
  DownArrowDraw,
  DetailFields,
} from "../../styledElements";
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer";
import { DatePicker } from "antd";
import {
  DatePickerY,
  GlobalSet,
  DisabledStyles,
  PaperMachineQualitySelect,
  PaperMachineGradeSelect,
} from "../../pageStyled";
import moment from "moment";
import {
  getDeckleOrderDetails,
  getOrderDetails,
  getPackagingList,
  getPosData,
  getPosDetails,
} from "../../../Services/orderServices";
import {
  getProductDetails,
  getProductsData,
} from "../../../Services/productServices";
import { DeliveryaddressSpacing } from "../../pageStyled";
import styled from "styled-components";
import { Collapse } from "antd";
import {
  lengthUnit,
  weightUnit,
  conversionFactorTonneToUnits,
  orderDim_Rewinder_Unit_Conversion,
} from "../../../Utils/Constant/MeasurementUnitList";
import { getUnitData } from "../../../Services/measurementService";
import { getReelCoreValues } from "../../../Services/settingsServices";
import Multiselect from "multiselect-react-dropdown";
const { Option } = Select;
const grainTypeData = ["Long Grain", "Short Grain"];
const deckleWidthUnitData = ["mm", "cm"];
const provinceData = ["India", "USA"];
const orderTypeData = ["Sheet", "Reel"];
const productSpecData = [
  "Kraft Paper / Corrugated Paper",
  "Duplex Coated Duplex Paper",
  "Writing and Printing Paper",
];
const currencyUnitData = ["US Dollor", "Rupees", "GB Pound"];

const cityData = {
  India: ["Arunachal Pradesh", "Andra Pradesh", "Bihar", "Chhattisgarh"],
  USA: ["Arizona", "California", "Colorado"],
};

const capitalize = (item) => item?.charAt(0).toUpperCase() + item?.slice(1);
const { Panel } = Collapse;
const { TextArea } = Input;
const MultiSelectCard = styled.div`
  .optionContainer li:hover,
  .optionContainer .highlight {
    background: #edebe9;
    color: black;
  }
  .multiSelectContainer input[type="text"] {
    padding-left: 15px !important;
    width: 100%;
  }
  .optionContainer .highlight {
    background: white;
    color: black;
  }
  .optionListContainer {
    z-index: 100;
  }
  li.groupHeading {
    color: black;
    padding: 5px 15px;
    pointer-events: none;
    font-weight: 500;
  }
  .multiSelectContainer ul {
    border-radius: 0px;
    margin-top: 4px;
    width: 332px;
  }
  .multiSelectContainer input[type="checkbox"] {
    accent-color: rgb(234, 101, 91);
  }
`;
const ViewDeckleOrder = (props) => {
  const [checkedBox, setCheckedBox] = useState(false);
  const [cities, setCities] = useState(cityData[provinceData[0]]);
  const [secondCity, setSecondCity] = useState(cityData[provinceData[0]][0]);
  const [orderDetails, setOrderDetails] = useState();
  const [productDetails, setProductDetails] = useState();
  const [poDetails, setPoDetails] = useState();
  const [details, setDetails] = useState();
  const [form] = Form.useForm();
  const [rewinderDia, setRewinderDia] = useState(false);
  const [mixedGrain, setMixedGrain] = useState(false);
  const [grainChanges, setGrainChanges] = useState(false);
  const [priceUnit, setPriceUnit] = useState("");
  const [productData, setProductData] = useState();
  const [products, setProducts] = useState([]);
  const [netPrice, setNetPrice] = useState("");
  const [packagingData, setPackagingData] = useState([]);
  const [orderQuantity, setOrderQuantity] = useState("weight");
  const [unitPlaceholder, setUnitPlaceholder] = useState();
  const [measurementData, setMeasurementData] = useState(props?.unitData);
  const [weightUnitList, setWeightUnitList] = useState([]);
  const [pendingQuantity, setPendingQuantity] = useState("");
  const [reelValues, setReelvalues] = useState(props?.reelValuesArray);
  const [coreValues, setCoreValues] = useState();
  const [reelCoreData, setReelCoreData] = useState();
  const [selectedReelOD, setSelectedReelOD] = useState();
  const [outerDiameter, setOuterDiameter] = useState("constant");
  const [reelODValidationError, setReelODValidationError] = useState(false);
  const [coreOdValidationError, setCoreOdValidationError] = useState(false);
  const [coreOD, setCoreod] = useState("");
  const [reelOD, setReelod] = useState("");
  const [selectedType, setSelectedType] = useState();
  const [plannedReels, setPlannedReels] = useState(0);
  const [grainValue, setGrain] = useState("");
  const [lengthValue, setLength] = useState("");
  const [widthValue, setWidth] = useState("");
  const [weightValue, setWeight] = useState("");
  const [planningWeightValue, setPlanningWeightValue] = useState("");
  const [planningQuantityValue, setPlanningQuantityValue] = useState("");
  const [quantityValue, setQuantity] = useState("");
  const [dealerPriceValue, setDealerPriceValue] = useState();
  const [plannedWeight, setPlannedWeight] = useState(0);
  const [inputValue, setInputValue] = useState(plannedWeight);
  const rewinderType = [
    { label: "Constant", value: "constant" },
    { label: "Range", value: "range" },
  ];
  const orderQuantityTab = details
    ? [
        { label: "Weight", value: "Weight" },
        { label: details.type, value: details.type },
      ]
    : [];
  const multiselectStyle = {
    chips: {},
    searchBox: {
      border: "2px solid #dfe1e6",
      "border-radius": "8px",
      width: "332px",
      "background-color": "var(--form-element-bg)",
    },
    option: {
      // To change css for dropdown options
      //background : "gray"
    },
  };
  useEffect(() => {
    setInputValue(plannedWeight);
  }, [plannedWeight]);
  const calculatePlannedWeight = (size, bulk, reelOd, coreOd, plannedReels) => {
    // console.log(size, bulk, reelOd, coreOd, plannedReels);
    const value =
      (3.14 *
        parseFloat(size) *
        (Math.pow(parseFloat(reelOd), 2) - Math.pow(parseFloat(coreOd), 2)) *
        parseFloat(plannedReels)) /
      (1000 * 1000 * parseFloat(bulk) * 4);
    // console.log(value);
    let plannedWeightValue =
      value * conversionFactorTonneToUnits[unitPlaceholder];
    // console.log(plannedWeightValue);
    setPlannedWeight(plannedWeightValue ? plannedWeightValue.toFixed(3) : 0);
    // setPlannedWeight({
    // plannedWeightValue ? plannedWeightValue.toFixed(3) : 0,
    // });
  };

  useEffect(() => {
    // console.log("props", props.selectedOrderNo);
    // getOrderDetails(props.selectedOrderNo)
    //   .then((response) => {
    //     setOrderDetails(response.data);
    //     // console.log("od", orderDetails);
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });

    if (props?.selectedOrderNo)
      getDeckleOrderDetails(props.selectedOrderNo)
        .then((response) => {
          setOrderDetails(response.data);
          // console.log("od", orderDetails);
        })
        .catch((error) => {
          console.log(error);
        });
    return () => {
      setOrderDetails();
    };
  }, [props]);

  useEffect(() => {
    if (details) {
      setOrderQuantity(
        details.quantityType === "weight" ? "Weight" : details.type
      );
      plannedWeightCal();
      // const plannedQuantityTemp = calcPlannedWeight(
      //   details,
      //   details?.id_od_type,
      //   details?.reel_od,
      //   details?.rewinder_reels
      // );
      // console.log(plannedQuantityTemp);
      // setPlannedQUa
    }
    if (orderDetails?.type === "sheet") {
      setLength(orderDetails?.length);
      setGrain(orderDetails?.grain?.toLowerCase());
    }
    orderDetails?.width ? setWidth(orderDetails?.width) : setWidth(0);
    if (
      orderDetails?.type == "reel" &&
      orderDetails?.quantity_type == "reel_sheet"
    ) {
      orderDetails?.outer_dia.length
        ? setReelod(orderDetails?.outer_dia[0])
        : setReelod("");
    } else {
      let outerDiaArr = [];
      for (let i = 0; i < orderDetails?.outer_dia.length; i++) {
        let outerDiaObj = {};
        outerDiaObj["value"] = orderDetails?.outer_dia[i];
        outerDiaArr.push(outerDiaObj);
      }

      setSelectedReelOD(outerDiaArr);
    }
    orderDetails?.inner_dia
      ? setCoreod(orderDetails?.inner_dia)
      : setCoreod("");
    orderDetails?.quantity_type === "weight"
      ? setWeight(orderDetails?.weight)
      : setWeight("");
    orderDetails?.quantity_type === "reel_sheet"
      ? setQuantity(orderDetails?.no_of_reel_sheet)
      : setQuantity("");
    orderDetails?.planning_weight
      ? setPlanningWeightValue(orderDetails?.planning_weight)
      : setPlanningWeightValue("");
    orderDetails?.planning_quantity
      ? setPlanningQuantityValue(orderDetails?.planning_quantity)
      : setPlanningQuantityValue("");
    orderDetails?.dealer_price
      ? setDealerPriceValue(orderDetails?.dealer_price)
      : setDealerPriceValue("");
    // plannedWeightCal();
    // console.log(details);
  }, [details]);
  useEffect(() => {
    getProductsData({ status: "active" })
      .then((response) => {
        setProducts(response);
      })
      .catch((error) => {
        console.log("Error in fetching products list:", error);
      });
    !props?.unitData && getUnitData()
      .then((unitData) => {
        setMeasurementData(unitData);
        // setDimesionUnitList(unitData.data.units_management.length.data);
        setWeightUnitList(unitData.data.units_management.weight.data);
        // let currencyData = currency_List?.filter((item) =>
        //   unitData.data.units_management.currency.data.includes(item.code)
        // );
        // setCurrencyUnitData(currencyData);
      })
      .catch((err) => {
        console.log(err);
      });
    !props?.reelValuesArray && getReelCoreValues()
      .then((response) => {
        setReelCoreData(response);
        const reelData = response.reel_data.map((item) => {
          return {
            value: item[0] + " " + item[1],
          };
        });
        const coreData = response.core_data.map((item) => {
          return {
            value: item[0] + " " + item[1],
          };
        });
        setCoreValues(coreData);
        setReelvalues(reelData);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  // useEffect(() => {
  //   (async () => {
  //     if (selectedType) {
  //       try {
  //         const resp = await getPackagingList(selectedType);
  //         if (!resp.error) {
  //           setPackagingData(resp.data);
  //         }
  //       } catch (err) {
  //         console.log(err);
  //       }
  //     }
  //   })();
  // }, [selectedType]);
  useEffect(() => {
    setRewinderDia(false);
    // getProductDetails(orderDetails.product)
    //   .then((response) => {
    //     setProductDetails(response.data);
    //     // console.log("pd", productDetails);
    //   })
    //   .catch((error) => {
    //     console.log(error.message);
    //   });

    if (orderDetails) {
      getProductDetails(orderDetails.product)
        .then((response) => {
          setProductDetails(response.data);
        })
        .catch((error) => {
          console.log("Error in product data loading:", error);
        });
      if (orderDetails?.reel_diameter === "multiple") {
        setRewinderDia(true);
      }
      setMixedGrain(orderDetails?.grain_mixing);
      setGrainChanges(orderDetails?.rotation);
      getPosDetails(orderDetails.po)
        .then((response) => {
          setPoDetails(response.data);
          // console.log("po", poDetails);
        })

        .catch((error) => {
          console.log(error);
        });

      if (orderDetails?.quantity_type === "weight") {
        setOrderQuantity("weight");
        setUnitPlaceholder(orderDetails?.units.weight);
      } else {
        setOrderQuantity(orderDetails?.type);
        setUnitPlaceholder(
          measurementData?.data?.units_management?.weight.default
        );
      }
      if (
        orderDetails?.quantity_type == "reel_sheet" &&
        orderDetails?.type == "reel"
      ) {
        setPendingQuantity(orderDetails?.total_pending_quantity?.quantity);
      } else {
        setPendingQuantity(orderDetails?.total_pending_quantity?.weight);
      }
    }
    return () => {
      setProductDetails();
      setPoDetails();
    };
  }, [orderDetails]);

  const onChangeHandlerBox = (e) => {
    setCheckedBox(e.target.checked);
    !checkedBox
      ? form.setFieldsValue({
          delivery_address_line_1: poDetails.delivery_address_line_1,
          delivery_address_line_2: poDetails.delivery_address_line_2,
          delivery_state: poDetails.delivery_state,
          delivery_city: poDetails.delivery_city,
          delivery_pincode: poDetails.delivery_pincode,
          delivery_country: poDetails.delivery_country,
        })
      : form.setFieldsValue({
          delivery_address_line_1: orderDetails.delivery_address_line_1,
          delivery_address_line_2: orderDetails.delivery_address_line_2,
          delivery_state: orderDetails.delivery_state,
          delivery_city: orderDetails.delivery_city,
          delivery_pincode: orderDetails.delivery_pincode,
          delivery_country: orderDetails.delivery_country,
        });
  };

  const handleProvinceChange = (value) => {
    setCities(cityData[value]);
    // setSecondCity(cityData[value][0]);
  };
  const onSecondCityChange = (value) => {
    setSecondCity(value);
  };

  const onFinish = (e) => {
    // console.log(e);
    setRewinderDia(false);
    setMixedGrain(false);
    setGrainChanges(false);
    props.onClose();
  };

  const onChangeCollpase = (key) => {
    // console.log(key);
    plannedWeightCal();
  };
  useEffect(() => {
    (async () => {
      if (selectedType) {
        try {
          const resp = await getPackagingList(selectedType);
          if (!resp.error) {
            setPackagingData(resp.data);
          }
        } catch (err) {
          console.log(err);
        }
      }
    })();
  }, [selectedType]);
  useEffect(() => {
    form.resetFields();
    setCheckedBox(false);
    if (productDetails && orderDetails) {
      let plannedQuant;
      if (
        orderDetails?.type === "reel" &&
        orderDetails?.quantity_type === "reel_sheet"
      ) {
        plannedQuant = orderDetails?.planning_quantity.toFixed(3) + " Reels";
      } else
        plannedQuant =
          orderDetails?.planning_weight.toFixed(3) +
          " " +
          capitalize(
            orderDetails?.units?.planned_weight
              ? orderDetails?.units?.planned_weight
              : "CM"
          );
          let pendingQuant;
          if (orderDetails?.type === "reel" && orderDetails?.quantity_type === "reel_sheet") {
            pendingQuant = orderDetails?.total_pending_quantity.quantity + " Reels";
          } else if (
            orderDetails?.type === "sheet" &&
            orderDetails?.quantity_type === "reel_sheet"
          ) {
            pendingQuant =
              orderDetails?.total_pending_quantity.weight +
              capitalize(orderDetails?.total_pending_quantity.units.weight) +
              " (" +
              Math.round(orderDetails?.total_pending_quantity.quantity) +
              " " +
              "Sheets)";
          } else
            pendingQuant =
              orderDetails?.total_pending_quantity.weight +
              " " +
          capitalize(orderDetails?.total_pending_quantity.units.weight);
          setPendingQuantity(pendingQuant)
      setDetails({
        number: orderDetails.number,
        pono: orderDetails.po,
        productSpec: orderDetails.product_spec,
        type: capitalize(orderDetails.type),
        grain: orderDetails.grain,
        length: orderDetails.length,
        width: orderDetails.width,
        unit: orderDetails.unit,
        weight: orderDetails.weight % 1 === 0 ? orderDetails.weight : orderDetails.weight.toFixed(3),
        quantity: orderDetails.quantity,
        rewinder_reels: orderDetails?.quantity,
        core_od: orderDetails.core_id,
        reel_od: orderDetails.reel_od,
        reel_unit: orderDetails.unit,
        price: parseFloat(orderDetails.quoted_price).toFixed(3),
        currency: orderDetails.currency,
        net_price: parseFloat(orderDetails.net_price).toFixed(3),
        delivery_date: moment(orderDetails.delivery_date).format("DD MM YYYY"),
        delivery_address_line_1: orderDetails.delivery_address_line_1,
        delivery_address_line_2: orderDetails.delivery_address_line_2,
        delivery_state: orderDetails.delivery_state,
        delivery_city: orderDetails.delivery_city,
        delivery_pincode: orderDetails.delivery_pincode,
        delivery_country: orderDetails.delivery_country,
        remarks: orderDetails.remarks,

        product_code: `${orderDetails.product} - ${productDetails.name}`,
        quantityType: orderDetails.quantity_type,
        plannedWeight:
          orderDetails.planned_weight != 0
            ? orderDetails.planned_weight.toFixed(3)
            : 0,
        no_of_reel_sheet: parseInt(orderDetails.no_of_reel_sheet),
        lower_tolerance: orderDetails?.tolerances?.weight?.lower_tolerance,
        upper_tolerance: orderDetails?.tolerances?.weight?.upper_tolerance,
        calculated_lower_tolerance: orderDetails?.calculated_lower_tolerance,
        calculated_upper_tolerance: orderDetails?.calculated_upper_tolerance,
        units: orderDetails.units ? orderDetails.units : "",
        packaging_details: orderDetails?.packaging_details,
        total_pending_quantity: orderDetails?.total_pending_quantity,
        pending_quantity: orderDetails.pending_quantity,
        planned_sheets: orderDetails?.planned_sheets,
        planning_weight: orderDetails?.planning_weight,
        planning_quantity: orderDetails?.planning_quantity,
        minimum_reel_od: orderDetails?.minimum_reel_od,
        maximum_reel_od: orderDetails?.maximum_reel_od,
        inner_dia: orderDetails?.inner_dia,
        cal_upper_tolerance:
          orderDetails?.tolerances?.weight?.calculated_upper_tolerance,
        cal_lower_tolerance:
          orderDetails?.tolerances?.weight?.calculated_lower_tolerance,
        bulk: orderDetails?.bulk,
        plannedQuant: plannedQuant,
        customer_price: orderDetails?.customer_price,
        core_id: orderDetails?.inner_dia
          ? orderDetails?.inner_dia?.split(" ")[0]
            ? parseFloat(orderDetails?.inner_dia?.split(" ")[0])
            : 0
          : 0,
      });
      setPriceUnit(orderDetails?.units?.per_weight_unit);
      if (
        orderDetails?.type == "reel" &&
        orderDetails?.quantity_type == "reel_sheet"
      ) {
        orderDetails?.outer_dia.length
          ? setReelod(orderDetails?.outer_dia[0])
          : setReelod("");
        let outerDiaArr = [];
        for (let i = 0; i < orderDetails?.outer_dia.length; i++) {
          let outerDiaObj = {};
          outerDiaObj["value"] = orderDetails?.outer_dia[i];
          outerDiaArr.push(outerDiaObj);
        }
        setSelectedReelOD(outerDiaArr);
        // orderDetails?.outer_dia.length
      } else {
        let outerDiaArr = [];
        for (let i = 0; i < orderDetails?.outer_dia.length; i++) {
          let outerDiaObj = {};
          outerDiaObj["value"] = orderDetails?.outer_dia[i];
          outerDiaArr.push(outerDiaObj);
        }
        setSelectedReelOD(outerDiaArr);
        // console.log(outerDiaArr)
      }
      setSelectedType(orderDetails?.type);
      setOuterDiameter(orderDetails?.id_od_type);
    }
    return () => {
      setDetails();
    };
  }, [orderDetails, productDetails]);
  const plannedWeightCal = () => {
    setPlannedWeight(0);
    let reels = details?.rewinder_reels;
    let size;
    if (selectedType === "reel") {
      size = widthValue;
    } else {
      size =
        grainValue === "Long Grain" ||
        grainValue === "long" ||
        grainValue === "long grain"
          ? parseFloat(widthValue) > parseFloat(lengthValue)
            ? lengthValue
            : widthValue
          : parseFloat(lengthValue) > parseFloat(widthValue)
          ? lengthValue
          : widthValue;
    }
    // console.log(coreOD, size, reelOD);
    if (size && coreOD && (selectedReelOD || reelOD)) {
      let reelDiaUnit;
      let reelODValue;
      if (selectedType === "reel" && orderQuantity === "reel") {
        reelDiaUnit = reelOD?.split(" ")[1];
        reelODValue = reelOD?.split(" ")[0];
      } else {
        reelDiaUnit = selectedReelOD[0]?.value.split(" ")[1];
        reelODValue = selectedReelOD[0]?.value.split(" ")[0];
      }
      let reelConversionValue = orderDim_Rewinder_Unit_Conversion[reelDiaUnit];

      let coreDiaUnit = coreOD.split(" ")[1];
      let coreConversionValue = orderDim_Rewinder_Unit_Conversion[coreDiaUnit];

      let dimensionUnit;

      dimensionUnit = orderDetails?.units?.width;

      // let dimensionUnit = form.getFieldValue("dimensionUnit");
      let conversionValue = orderDim_Rewinder_Unit_Conversion[dimensionUnit];
      // console.log(size, reelODValue, coreOD, reels);
      calculatePlannedWeight(
        size * conversionValue,
        productData?.bulk,
        reelODValue * reelConversionValue,
        coreOD.split(" ")[0] * coreConversionValue,
        reels
      );
    } else {
      if (selectedType === "reel") {
        form.setFieldsValue({ planned_weight: 0 });
      } else {
        if (selectedType === "sheet" && orderQuantity === "weight") {
          if (planningWeightValue) {
            setPlannedWeight(parseFloat(planningWeightValue).toFixed(3));
            // form.setFieldsValue({
            //   planned_weight: parseFloat(planningWeightValue).toFixed(3),
            // });
          } else {
            form.setFieldsValue({ planned_weight: 0 });
          }
        } else {
          let dimensionUnit;

          dimensionUnit = orderDetails?.units?.width;

          // let dimensionUnit = form.getFieldValue("dimensionUnit");
          let conversionValue =
            orderDim_Rewinder_Unit_Conversion[dimensionUnit];

          let length_Value = lengthValue * conversionValue;
          let width_Value = widthValue * conversionValue;

          const value =
            (length_Value * width_Value * quantityValue * productData?.gsm) /
            (10000 * 1000000);
          // console.log(lengthValue, widthValue);
          let plannedWeightValue =
            value * conversionFactorTonneToUnits[unitPlaceholder];
          // console.log(plannedWeightValue);
          setPlannedWeight(
            plannedWeightValue ? plannedWeightValue.toFixed(3) : 0
          );
          // form.setFieldsValue({
          //   planned_weight: plannedWeightValue
          //     ? plannedWeightValue.toFixed(3)
          //     : 0,
          // });
        }
      }
    }
  };

  useEffect(() => {
    if (products.length && orderDetails) {
      let selectedProd = products?.filter(
        (item) => item.code === orderDetails?.product
      );
      // console.log(selectedProd[0]);
      setProductData(selectedProd[0]);
      // setFirstLoad(true);
    }
  }, [orderDetails, products]);

  return details ? (
    <RightDrawerSidebar
      title={`Order Details - #${details?.number}`}
      subtitle=""
      visible={props.visible}
      onClose={() => {
        setRewinderDia(false);
        setMixedGrain(false);
        setGrainChanges(false);
        props.onCloseGrade();
      }}
    >
      {/* {console.log("data", details)} */}

      <RightDrawerContainer>
        <div className="resetPassForm removePadLeft">
          <DetailFields className="marginBtnP">
            <HaberForm>
              <Form
                name="basic"
                form={form}
                autoComplete="off"
                className="haberLogin haberSignup"
                style={{ marginTop: "0" }}
                onFinish={onFinish}
              >
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Order type</h5>
                    <p>The order can be of reel or sheet type</p>
                  </div>
                  <Form.Item
                    name="Order Type"
                    rules={[{ required: true }]}
                    initialValue={
                      details.type ? capitalize(details?.type) : null
                    }
                    className="selectForm"
                  >
                    <Select
                      placeholder="Select"
                      disabled
                      suffixIcon={<DownArrowDraw />}
                    >
                      {orderTypeData.map((orderType) => (
                        <Option key={orderType}>{orderType}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
                {/* product name */}
                {/* <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Product Name</h5>
                    <p>Unique name to identify the product</p>
                  </div>
                  <Form.Item
                    name="product_code"
                    rules={[{}]}
                    className="selectForm"
                    initialValue={details?.product_code}
                  >
                    <Select
                      placeholder="Select Product"
                      suffixIcon={<DownArrowDraw />}
                      //  onChange={handleProduct}
                      disabled
                    >
                      <Option key={details?.product_code}>
                        {details?.product_code}
                      </Option>
                    </Select>
                  </Form.Item>
                </div> */}
                {/* order number */}
                {/* <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Order Number</h5>
                    <p>A unique auto-generated code to identify this order</p>
                  </div>
                  <Form.Item
                    name="Grade Name"
                    rules={[{ required: true }]}
                    initialValue={details?.number}
                    className=""
                  >
                    <Input disabled placeholder="Enter PO Number" />
                  </Form.Item>
                </div> */}
                {/* product specs */}
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Product Specifications</h5>
                    <p>Combination of Grade/GSM/BF/Quality</p>
                  </div>
                  <Form.Item
                    name="Product Spec"
                    rules={[{}]}
                    // initialValue={`${details?.grade}/${details?.gsm}/${
                    //   details?.burst_factor
                    // }${details?.quality ? `/${details.quality}` : ""}`}
                    initialValue={details?.productSpec}
                    className="selectForm"
                  >
                    <Select
                      placeholder="Select"
                      disabled
                      suffixIcon={<DownArrowDraw />}
                    >
                      {productSpecData.map((productSpec) => (
                        <Option key={productSpec}>{productSpec}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
                {/* order dimentions */}
                <div className="drawerField removeStar">
                  <div className="titleWithText">
                    <h5>Order Dimension</h5>
                    <p>
                      {details.type !== "Reel"
                        ? "The width and length of the order"
                        : "The width of the order"}
                    </p>
                  </div>
                  <Row className="centerAlign justifyCSBetween">
                    {details.type !== "Reel" && (
                      <Col span={8}>
                        <div
                          className="boxFormType"
                          style={{ marginBottom: "0" }}
                        >
                          <Form.Item
                            // label="Length"
                            name="Length"
                            rules={[{ required: true }]}
                            initialValue={details.length}
                            className="dBlock"
                            style={{ marginBottom: "0px" }}
                          >
                            <Input placeholder="Length" disabled />
                          </Form.Item>{" "}
                          <p>Length</p>
                        </div>
                      </Col>
                    )}
                    <Col span={details.type !== "Reel" ? 8 : 16}>
                      <div className="boxFormType">
                        <Form.Item
                          // label="Width"
                          name="Width"
                          rules={[{ required: true }]}
                          initialValue={details.width}
                          className="dBlock"
                          style={{ marginBottom: "0px" }}
                        >
                          <Input placeholder="Width" disabled />
                        </Form.Item>
                        <p>Width</p>
                      </div>
                    </Col>
                    <Col span={7}>
                      <div className="boxFormType unitSelect">
                        <Form.Item
                          // label="Unit"
                          name="Order Unit"
                          rules={[{ required: true }]}
                          // initialValue={details?.unit}
                          initialValue={details.units.width}
                          className="dBlock"
                          style={{ marginBottom: "0px" }}
                        >
                          <Select
                            placeholder="Unit"
                            disabled
                            suffixIcon={<DownArrowDraw />}
                          >
                            {deckleWidthUnitData.map((deckleWidth) => (
                              <Option
                                key={deckleWidth.value}
                                value={deckleWidth.value}
                              >
                                {deckleWidth}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                        <p style={{ marginLeft: "4px" }}>Unit</p>
                      </div>
                    </Col>
                  </Row>
                </div>
                {details.type !== "Reel" && (
                  <div className="drawerField">
                    <div className="titleWithText">
                      <h5>Grain</h5>
                      <p>The order can be of long or short grain</p>
                    </div>
                    <Form.Item
                      name="Grade Alias"
                      rules={[{ required: true }]}
                      initialValue={
                        details.grain ? capitalize(details.grain) : null
                      }
                      className="selectForm"
                    >
                      <Select
                        placeholder={"Select"}
                        suffixIcon={<DownArrowDraw />}
                        disabled
                        // defaultValue={grainTypeData[0]}
                      >
                        {grainTypeData.map((grainType) => (
                          <Option key={grainType}>{grainType}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Col span={24} style={{ marginTop: "-16px" }}>
                      <Row className="centerAlign justifyCSBetween">
                        <Col>
                          <Checkbox
                            disabled={true}
                            checked={mixedGrain}
                          ></Checkbox>
                          <span
                            style={{
                              marginLeft: "5px",
                              fontSize: "12px",
                              fontWeight: "500",
                              fontSize: "12px",
                              fontFamily: "var(--sf-pro-text)",
                              color: "var(--color-text-title)",
                              lineHeight: "20px",
                            }}
                          >
                            Allow mixed grain for this order
                          </span>
                        </Col>
                      </Row>
                    </Col>
                    <Col span={24} style={{ marginBottom: "8px" }}>
                      <Row className="centerAlign justifyCSBetween">
                        <Col>
                          <Checkbox
                            disabled={true}
                            checked={grainChanges}
                          ></Checkbox>
                          <span
                            style={{
                              marginLeft: "5px",
                              fontSize: "12px",
                              fontWeight: "500",
                              fontSize: "12px",
                              fontFamily: "var(--sf-pro-text)",
                              color: "var(--color-text-title)",
                              lineHeight: "20px",
                            }}
                          >
                            Allow grain changes for this order
                          </span>
                        </Col>
                      </Row>
                    </Col>
                  </div>
                )}

                {/* <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Order Weight</h5>
                    <p>Weight of order in Tonnes</p>
                  </div>
                  <Form.Item
                    name="Weight"
                    rules={[{ required: true }]}
                    initialValue={details.weight}
                    className=""
                  >
                    <Input
                      placeholder="Enter weight"
                      value={details.weight}
                      disabled
                    />
                  </Form.Item>
                </div>
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Quantity</h5>
                    <p>Number of reels/sheets</p>
                  </div>
                  <Form.Item
                    name="Quantity"
                    rules={[{ required: true }]}
                    initialValue={details.quantity}
                    className=""
                  >
                    <Input placeholder="Enter quantity" disabled />
                  </Form.Item>
                </div>
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Number of Rewinder Reels</h5>
                    <p>The number of reels required to fulfill the order</p>
                  </div>
                  <Form.Item
                    name="Reels"
                    rules={[{ required: true }]}
                    initialValue={details.rewinder_reels}
                    className=""
                  >
                    <Input placeholder="Enter the number of reels" disabled />
                  </Form.Item>
                </div> */}

                {/* order quantity */}
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Order Quantity</h5>
                    <p>Order format and quantity</p>
                  </div>
                  <div
                    className="switchRadio twoSwitch"
                    style={{ justifyContent: "center", display: "flex" }}
                  >
                    <Radio.Group
                      disabled
                      options={orderQuantityTab}
                      optionType="button"
                      buttonStyle="solid"
                      value={
                        details.quantityType === "weight"
                          ? "Weight"
                          : details.type
                      }
                    />
                  </div>
                  {details.quantityType === "weight" ? (
                    <>
                      <div className="subTitleWithText">
                        <p>Weight of order</p>
                      </div>
                      <Row className="centerAlign justifyCSBetween">
                        <Col span={13}>
                          <div className="boxFormType">
                            <Form.Item
                              name="weight"
                              rules={[
                                { required: true },
                                {
                                  pattern: new RegExp(/^\d+(\.\d+)?$/),
                                  message:
                                    "Only decimal characters are allowed",
                                },
                              ]}
                              className=""
                              initialValue={details.weight}
                            >
                              <Input placeholder="Enter weight" disabled />
                            </Form.Item>
                          </div>
                        </Col>
                        <Col span={10}>
                          <div className="boxFormType ">
                            <Form.Item
                              name="weightUnit"
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                              ]}
                              className="dBlock"
                              initialValue={weightUnit[
                                details.units.weight
                              ]?.displayName?.toUpperCase()}
                            >
                              <Input disabled />
                            </Form.Item>
                          </div>
                        </Col>
                      </Row>
                      {/* tolerances */}
                      <Collapse
                        onChange={onChangeCollpase}
                        expandIconPosition="right"
                        bordered={false}
                        style={{ backgroundColor: "white", marginTop: "-15px" }}
                      >
                        <Panel
                          header={
                            "Tolerance -" +
                            details?.upper_tolerance +
                            " to +" +
                            details?.lower_tolerance +
                            " %"
                          }
                          style={{ fontStyle: "italic", marginLeft: "-12px" }}
                        >
                          <Row
                            style={{ marginTop: "3px" }}
                            className="centerAlign  justifyCSBetween"
                          >
                            <Col span={8} className="blockBreak">
                              <div className="titleWithText">
                                <p
                                  style={{
                                    marginTop: "7px",
                                    fontStyle: "initial",
                                    fontSize: "12px",
                                    fontFamily: "var(--sf-pro-text)",
                                    color: "var(--color-text-title)",
                                    lineHeight: "20px",
                                  }}
                                >
                                  Upper Tolerance{" "}
                                </p>
                              </div>
                            </Col>
                            <Col span={8} className="blockBreak">
                              <div
                                className="boxFormType"
                                style={{ marginBottom: "0" }}
                              >
                                <Form.Item
                                  label=""
                                  name="order_upper_tolerance"
                                  rules={[
                                    {
                                      pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                      message: "Only Numeric value is possible",
                                    },
                                    {
                                      required: true,
                                      message: "This field is required",
                                    },
                                  ]}
                                  className="dBlock"
                                  initialValue={details?.upper_tolerance?.toFixed(3)}
                                >
                                  <Input
                                    placeholder=""
                                    style={{ fontSize: "10px", height: "30px" }}
                                    // onChange={(e) => {
                                    //   onUpperTolChange(e, "order_tolerance");
                                    // }}
                                    disabled={true}
                                  />
                                </Form.Item>
                                <span
                                  className="nonEditable"
                                  style={{ fontSize: "13px", top: "6px" }}
                                >
                                  %
                                </span>
                              </div>
                            </Col>
                            <Col span={8} className="blockBreak">
                              <Col
                                span={8}
                                className="blockBreak"
                                style={{ maxWidth: "45%", marginLeft: "15px" }}
                              >
                                <div className="titleWithText">
                                  <p
                                    style={{
                                      fontSize: "12px",
                                      fontFamily: "var(--sf-pro-text)",
                                      color: "var(--color-text-title)",
                                      lineHeight: "20px",
                                      marginTop: "7px",
                                      fontStyle: "initial",
                                      width: "104px",
                                    }}
                                  >
                                    {details?.cal_upper_tolerance.toFixed(3) + " "}{" "}
                                    {weightUnit[
                                      unitPlaceholder
                                    ]?.displayName?.toUpperCase()}
                                  </p>
                                </div>
                              </Col>
                            </Col>
                          </Row>

                          <Row
                            style={{ marginTop: "0px" }}
                            className="centerAlign  justifyCSBetween"
                          >
                            <Col span={8} className="blockBreak">
                              <div className="titleWithText">
                                <p
                                  style={{
                                    marginTop: "7px",
                                    fontStyle: "initial",
                                    fontSize: "12px",
                                    fontFamily: "var(--sf-pro-text)",
                                    color: "var(--color-text-title)",
                                    lineHeight: "20px",
                                  }}
                                >
                                  Lower Tolerance{" "}
                                </p>
                              </div>
                            </Col>
                            <Col span={8} className="blockBreak">
                              <div
                                className="boxFormType"
                                style={{ marginBottom: "0" }}
                              >
                                <Form.Item
                                  label=""
                                  name="order_lower_tolerance"
                                  rules={[
                                    {
                                      pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                      message: "Only Numeric value is possible",
                                    },
                                    {
                                      required: true,
                                      message: "This field is required",
                                    },
                                  ]}
                                  className="dBlock"
                                  initialValue={details?.lower_tolerance?.toFixed(3)}
                                >
                                  <Input
                                    placeholder=""
                                    style={{ fontSize: "10px", height: "30px" }}
                                    // onChange={(e) => {
                                    //   onLowerTolChange(e, "order_tolerance");
                                    // }}
                                    disabled={true}
                                  />
                                </Form.Item>
                                <span
                                  className="nonEditable"
                                  style={{ fontSize: "13px", top: "6px" }}
                                >
                                  %
                                </span>
                              </div>
                            </Col>
                            <Col span={8} className="blockBreak">
                              <Col
                                span={8}
                                className="blockBreak"
                                style={{ maxWidth: "45%", marginLeft: "15px" }}
                              >
                                <div className="titleWithText">
                                  <p
                                    style={{
                                      fontSize: "12px",
                                      fontFamily: "var(--sf-pro-text)",
                                      color: "var(--color-text-title)",
                                      lineHeight: "20px",
                                      marginTop: "7px",
                                      fontStyle: "initial",
                                      width: "104px",
                                    }}
                                  >
                                    {details?.cal_lower_tolerance?.toFixed(3) + " "}{" "}
                                    {weightUnit[
                                      unitPlaceholder
                                    ]?.displayName?.toUpperCase()}
                                  </p>
                                </div>
                              </Col>
                            </Col>
                          </Row>
                        </Panel>
                      </Collapse>
                    </>
                  ) : (
                    <>
                      <div className="subTitleWithText">
                        <p>{`Number of ${details.type}s`}</p>
                      </div>
                      <Form.Item
                        name="quantity"
                        rules={[
                          { required: true },
                          {
                            pattern: new RegExp(/^[0-9]+$/),
                            message: "Only Numeric value is possible",
                          },
                        ]}
                        className=""
                        initialValue={
                          details?.type === "reel"
                            ? details.quantity
                            : details.no_of_reel_sheet
                        }
                      >
                        <Input placeholder="Enter quantity" disabled />
                      </Form.Item>
                    </>
                      )} 
                </div>

                {/* price details  */}
                {props.category==='so'?<></>:<>
                <div className="drawerField">
                  {" "}
                  <div className="titleWithText">
                    <h5>Price Details</h5>
                    <p>Quoted Price of the order</p>
                  </div>
                  <div className="titleWithText" style={{ marginTop: "-6px" }}>
                    <p>
                      Product Price:{" "}
                      {productData?.price && (
                        <span>
                          {productData?.symbol}{" "}
                          {parseFloat(productData?.price)?.toFixed(3)}
                          {" / "}
                          {productData?.units?.per_weight_unit
                            ? capitalize(
                                weightUnit[productData.units.per_weight_unit]
                                  ?.displayName
                              )
                            : "T"}
                        </span>
                      )}
                    </p>
                  </div>
                  <Row className="centerAlign  justifyCSBetween">
                    <Col style={{ paddingRight: "5px" }} span={9}>
                      <div
                        className="boxFormType"
                        style={{ marginBottom: "0" }}
                      >
                        {/* {dealerPriceValue} */}
                        <Form.Item
                          label={
                            "Dealer Price" +
                            (priceUnit
                              ? " / " + weightUnit[priceUnit]?.displayName
                              : "")
                          }
                          name="dealer_price"
                          rules={[
                            {
                              pattern: new RegExp(/^\d+(\.\d+)?$/),
                              message: "Only decimal values possible",
                            },
                          ]}
                          className="dBlock"
                          initialValue={dealerPriceValue}
                        >
                          <Input
                            placeholder={dealerPriceValue}
                            // onChange={}
                            disabled={true}
                          />
                        </Form.Item>
                      </div>
                    </Col>
                    <Col style={{ paddingRight: "5px" }} span={9}>
                      <div
                        className="boxFormType"
                        style={{ marginBottom: "0" }}
                      >
                        <Form.Item
                          label={
                            "Customer Price" +
                            (priceUnit
                              ? " / " + weightUnit[priceUnit]?.displayName
                              : "")
                          }
                          name="customer_price"
                          rules={[
                            {
                              pattern: new RegExp(/^\d+(\.\d+)?$/),
                              message: "Only decimal values possible",
                            },
                          ]}
                          className="dBlock"
                          initialValue={details?.customer_price}
                        >
                          <Input placeholder="Customer Price" disabled={true} />
                        </Form.Item>
                      </div>
                    </Col>
                    <Col span={6}>
                      <div className="boxFormType unitSelect">
                        <Form.Item
                          label="Currency"
                          name="currency"
                          rules={[{}]}
                          className="dBlock"
                          initialValue={details?.units?.net_price}
                        >
                          <Select
                            placeholder="Currency"
                            suffixIcon={<DownArrowDraw />}
                            showSearch
                            optionFilterProp="children"
                            onChange={(e) => {
                              // onCurrencyChange(e);
                            }}
                            disabled={true}
                          >
                            {currencyUnitData.map((currencyUnit) => (
                              <Option
                                key={currencyUnit.code}
                                value={currencyUnit.code}
                              >
                                <Tooltip title={currencyUnit.displayName}>
                                  {`${currencyUnit.code}`}
                                </Tooltip>
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <div className="titleWithText" style={{ marginTop: "-5px" }}>
                    <p>
                      Net Price: {details.net_price ? details.net_price : ""}
                    </p>
                  </div>
                </div>

                {/* <div className="drawerField removeStar">
                  <div className="titleWithText">
                    <h5>Price</h5>
                    <p>Price/Tonne of the order</p>
                  </div>
                  <Row className="centerAlign  justifyCSBetween">
                    <Col span={8}>
                      <div
                        className="boxFormType"
                        style={{ marginBottom: "0" }}
                      >
                        <Form.Item
                          label="Price"
                          name="Price"
                          rules={[{ required: true }]}
                          initialValue={details.price}
                          className="dBlock"
                        >
                          <Input placeholder="Price per Tonne" disabled />
                        </Form.Item>
                      </div>
                    </Col>
                    <Col span={8}>
                      <div className="boxFormType unitSelect">
                        <Form.Item
                          label="Currency"
                          name="Currency"
                          rules={[{}]}
                          initialValue={details?.currency}
                          className="dBlock"
                        >
                          <Select
                            placeholder="Currency"
                            disabled
                            suffixIcon={<DownArrowDraw />}
                            defaultValue={"Rupees"}
                          >
                            {currencyUnitData.map((currencyUnit) => (
                              <Option
                                key={currencyUnit.value}
                                value={currencyUnit.value}
                              >
                                {currencyUnit}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </Col>
                    <Col span={7}>
                      <div className="boxFormType">
                        <Form.Item
                          label="Net Price"
                          name="Net Price"
                          rules={[{}]}
                          initialValue={details.net_price}
                          className="dBlock"
                        >
                          <Input placeholder="Net Price" disabled />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                </div> */}

                {/* delivery date  */}
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Delivery Date</h5>
                    <p>Date when order needs to be delivered</p>
                  </div>
                  <div className="boxFormType">
                    <DatePickerY>
                      <Form.Item
                        name="Date"
                        initialValue={moment(
                          details.delivery_date,
                          "DD-MM-YYYY"
                        )}
                      >
                        <DatePicker disabled format={"DD/MM/YYYY"} />
                      </Form.Item>
                    </DatePickerY>
                  </div>
                </div>

                {/* delivery address  */}
                <div className="drawerField" style={{ marginBottom: "5px" }}>
                  <Collapse
                    onChange={onChangeCollpase}
                    expandIconPosition="right"
                    bordered={false}
                    style={{
                      backgroundColor: "white",
                      // transform: "translateY(5px)",
                      paddingTop: "5px",
                      // marginTop: "-12px",
                      // marginBottom: "-20px",
                    }}
                    className="deliAddCollapseIcon"
                  >
                    <Panel
                      header={
                        <div
                          style={{
                            marginLeft: "-12px",
                            marginBottom: "0px",
                            transform: "translateY(-20px)",
                          }}
                        >
                          <div className="titleWithText">
                            <h5>Delivery Address</h5>
                            <p style={{ width: "max-content" }}>
                              The postal address where order needs to be
                              delivered
                            </p>
                          </div>

                          {/* <div className="checklist-address">
                            <Checkbox
                              type="checkbox"
                              checked={checkedBox}
                              // onChange={onChangeHandlerBox}
                              disabled={true}
                            />
                            <p
                              style={{
                                fontSize: 14,
                                fontWeight: 100,
                              }}
                            >
                              The order address is same as the PO address
                            </p>
                          </div> */}
                        </div>
                      }
                    >
                      {/* <div className="titleWithText">
                        <h5>Delivery Address</h5>
                        <p>
                          The postal address where order needs to be delivered
                        </p>
                      </div> */}

                      <Col span={24}>
                        <Row className="centerAlign">
                          <DeliveryaddressSpacing>
                            <Col
                              span={24}
                              className="blockBreak haberdeliveryaddress"
                            >
                              <div className="boxFormType">
                                {/* <Form.Item
                            name="Contactaddress"
                            // rules={[{ required: true }]}
                            className=""
                          >
                            <GlobalSet>
                              <div className="checklist-address">
                                <Checkbox
                                  type="checkbox"
                                  checked={checkedBox}
                                  onChange={onChangeHandlerBox}
                                  disabled
                                />
                                <p
                                  style={{
                                    fontSize: 14,
                                    fontWeight: 100,
                                  }}
                                >
                                  The order address is same as PO address
                                </p>
                              </div>
                            </GlobalSet>
                          </Form.Item> */}
                                <DisabledStyles>
                                  <Form.Item
                                    name="delivery_address_line_1"
                                    rules={[{ required: true }]}
                                    initialValue={
                                      details?.delivery_address_line_1
                                    }
                                    // checkedBox
                                    //   ? poData[0].delivery_address_line_1
                                    // :

                                    className=""
                                  >
                                    <Input
                                      disabled
                                      className="disabled-check"
                                      placeholder="First Line of address"
                                      // value={''}
                                    />
                                  </Form.Item>
                                </DisabledStyles>
                              </div>

                              <div className="boxFormType">
                                <DisabledStyles>
                                  <Form.Item
                                    name="delivery_address_line_2"
                                    rules={[{}]}
                                    initialValue={
                                      details?.delivery_address_line_2
                                    }
                                    className=""
                                  >
                                    <Input
                                      disabled
                                      className="disabled-check"
                                      placeholder="Second Line of address"
                                    />
                                  </Form.Item>
                                </DisabledStyles>
                              </div>

                              <Col span={12} className="d-flex">
                                <div className="boxFormType">
                                  <DisabledStyles>
                                    <Form.Item
                                      name="delivery_country"
                                      rules={[{ required: true }]}
                                      initialValue={details?.delivery_country}
                                      className=""
                                    >
                                      <Select
                                        className="disabled-check"
                                        disabled
                                        suffixIcon={<DownArrowDraw />}
                                        // defaultValue={provinceData[0]}
                                        placeholder="Country"
                                        onChange={handleProvinceChange}
                                      >
                                        {provinceData.map((province) => (
                                          <Option key={province}>
                                            {province}
                                          </Option>
                                        ))}
                                      </Select>
                                    </Form.Item>
                                  </DisabledStyles>
                                </div>
                                <div className="boxFormType">
                                  <DisabledStyles>
                                    <Form.Item
                                      name="delivery_state"
                                      rules={[{ required: true }]}
                                      initialValue={details?.delivery_state}
                                      className=""
                                    >
                                      <Select
                                        disabled
                                        suffixIcon={<DownArrowDraw />}
                                        placeholder="State"
                                        // value={secondCity}
                                        // onChange={onSecondCityChange}
                                      >
                                        {cities.map((city) => (
                                          <Option key={city}>{city}</Option>
                                        ))}
                                      </Select>
                                    </Form.Item>
                                  </DisabledStyles>
                                </div>
                              </Col>
                              <Col span={12} className="d-flex">
                                <div
                                  className="boxFormType"
                                  style={{ marginBottom: "0" }}
                                >
                                  <DisabledStyles>
                                    <Form.Item
                                      name="delivery_city"
                                      rules={[{ required: true }]}
                                      initialValue={details?.delivery_city}
                                      className=""
                                    >
                                      <Input
                                        placeholder="City"
                                        disabled
                                        className="disabled-check"
                                      />
                                    </Form.Item>
                                  </DisabledStyles>
                                </div>
                                <div className="boxFormType">
                                  <DisabledStyles>
                                    <Form.Item
                                      name="delivery_pincode"
                                      rules={[{ required: true }]}
                                      initialValue={details?.delivery_pincode}
                                      className=""
                                    >
                                      <Input
                                        disabled
                                        className="disabled-check"
                                        placeholder="ZIP code"
                                      />
                                    </Form.Item>
                                  </DisabledStyles>
                                </div>
                              </Col>
                            </Col>
                          </DeliveryaddressSpacing>
                        </Row>
                      </Col>
                    </Panel>
                  </Collapse>
                </div>
                </>
                }
                {/* packaging date  */}
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Packaging Details</h5>
                    <p>
                      Type of packaging to be used for this item in shipping
                    </p>
                  </div>
                  <Form.Item
                    name="packaging_name"
                    className="selectForm"
                    initialValue={details?.packaging_details?.id?.toString()}
                  >
                    <Select
                      placeholder="Select Packaging"
                      suffixIcon={<DownArrowDraw />}
                      showSearch
                      optionFilterProp="children"
                      // onChange={(e) => {
                      //   handlePackaging(e);
                      // }}
                      disabled={true}
                    >
                      {packagingData.length &&
                        packagingData?.map((item) => (
                          <Option key={item.id}>
                            {item.name} -{" "}
                            {item.quantity_type === "weight"
                              ? item.weight +
                                " " +
                                (item.units && item.units.weight
                                  ? capitalize(
                                      weightUnit[item.units.weight]?.displayName
                                    )
                                  : "")
                              : item.quantity +
                                " " +
                                capitalize(item.type) +
                                "s"}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </div>

                {/* remarks */}
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Remarks</h5>
                    <p>Any other Information related to the order</p>
                  </div>
                  <Form.Item
                    name="Remarks"
                    rules={[{ required: true }]}
                    initialValue={details.remarks}
                    className=""
                  >
                    <TextArea
                      maxLength={100}
                      style={{ height: 90 }}
                      disabled
                      placeholder="Add Remarks"
                    />
                  </Form.Item>
                </div>

                {/* pending quantity  */}
                <div className="drawerField">
                  <Collapse
                    onChange={onChangeCollpase}
                    expandIconPosition="right"
                    bordered={false}
                    style={{
                      backgroundColor: "white",
                      marginTop: "-12px",
                      marginBottom: "-20px",
                    }}
                    className="planningDetailsCollapseIcon"
                  >
                    <Panel
                      header={
                        <div style={{ marginLeft: "-12px" }}>
                          <div className="titleWithText">
                            <h5>Planning Details</h5>
                            <p>
                              Quantity pending to be processed and associated
                              rewinder details for the quantity
                            </p>
                          </div>
                        </div>
                      }
                    >
                      <div className="titleWithText">
                        <p style={{ marginLeft: "-12px", marginTop: "-10px" }}>
                          Pending Quantity:{" "}
                          {/* {orderQuantity === "weight" ||
                          orderQuantity == "sheet"
                            ? details?.total_pending_quantity?.weight
                              ? details?.total_pending_quantity?.weight +
                                " " +
                                (details?.total_pending_quantity?.units?.weight
                                  ? capitalize(
                                      weightUnit[
                                        details?.total_pending_quantity?.units
                                          ?.weight
                                      ]?.displayName
                                    )
                                  : "")
                              : ""
                            : details?.total_pending_quantity?.quantity
                            ? details?.total_pending_quantity?.quantity +
                              " " +
                              capitalize(orderQuantity) +
                              "s"
                            : ""} */}
                          {pendingQuantity}
                          {/* {orderQuantity === "weight" ? (((pendingQuantity || pendingQuantity == 0) ? (pendingQuantity + " " + (unitPlaceholder ? capitalize(weightUnit[unitPlaceholder]?.displayName) : "")) : "")) : 
                      ((orderQuantity == "sheet") ? ((pendingQuantity + " (" + pendingQuantity + (unitPlaceholder ? capitalize(weightUnit[unitPlaceholder]?.displayName) : "") + ")")) :
                      ((pendingQuantity || pendingQuantity == 0) ? (pendingQuantity + " " + capitalize(orderQuantity) + "s") : ""))} */}
                        </p>
                      </div>

                      <div
                        className="drawerField"
                        style={{ marginLeft: "-12px", marginTop: "-19px" }}
                      >
                        <div className="titleWithText">
                          <h5>Quantity to be planned</h5>
                          <p>Quantity of the order to be planned</p>
                        </div>
                        <div
                          className=" switchRadio twoSwitch"
                          style={{
                            justifyContent: "center",
                            display: "flex",
                            marginRight: "-8px",
                          }}
                        >
                          <Radio.Group
                            options={orderQuantityTab}
                            optionType="button"
                            buttonStyle="solid"
                            value={orderQuantity}
                            disabled={true}
                          />
                        </div>
                        {/* {console.log(orderQuantity)} */}
                        {orderQuantity === "Weight" ? (
                          <>
                            <div className="subTitleWithText">
                              <p></p>
                            </div>
                            <div style={{ position: "relative" }}>
                              <Row className="centerAlign justifyCSBetween">
                                <Col span={13}>
                                  <div className="boxFormType">
                                    <Form.Item
                                      name="planning_weight"
                                      rules={[
                                        {
                                          required: true,
                                          message: "This field is required",
                                        },
                                        {
                                          pattern: new RegExp(
                                            /^\d+(\.\d{0,3})?$/
                                          ),
                                          message:
                                            "This value should be a non-zero positive value",
                                        },
                                        {
                                          pattern: new RegExp(
                                            /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                                          ),
                                          message:
                                            "Weight should be a number greater than zero",
                                        },
                                      ]}
                                      className="dBlock"
                                      initialValue={details?.planning_weight % 1 === 0 ? details?.planning_weight : details?.planning_weight?.toFixed(
                                        3
                                      )}
                                    >
                                      <Input
                                        style={{ width: "185px" }}
                                        placeholder="Enter weight"
                                        // onChange={(e) => {
                                        //   handlePlanningWeight(e);
                                        // }}
                                        disabled={true}
                                      />
                                    </Form.Item>
                                  </div>
                                </Col>
                                <Col span={10}>
                                  <div
                                    className="boxFormType"
                                    style={{ marginLeft: "10px" }}
                                  >
                                    <Form.Item
                                      name="planning_weightUnit"
                                      rules={[
                                        {
                                          required: true,
                                          message: "This field is required",
                                        },
                                      ]}
                                      className="dBlock"
                                      initialValue={unitPlaceholder}
                                    >
                                      <Select
                                        placeholder="Unit"
                                        suffixIcon={<DownArrowDraw />}
                                        disabled={true}
                                      >
                                        {/* {weightUnitList?.map((unitItem) => (
                                          <Option
                                            key={unitItem}
                                            value={unitItem}
                                          >
                                            {weightUnit[unitItem]?.displayName}
                                          </Option>
                                        ))} */}
                                      </Select>
                                    </Form.Item>
                                  </div>
                                </Col>
                                {/* {planningWtErr ? (
                                  <span
                                    className="errorText"
                                    style={{
                                      color: "#ea4e2c",
                                      marginTop: "-17px",
                                      marginBottom: "5px",
                                    }}
                                  >
                                    Quantity to be planned cannot be more than
                                    the pending quantity
                                  </span>
                                ) : null} */}
                              </Row>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="subTitleWithText">
                              <p></p>
                            </div>
                            <div style={{ position: "relative" }}>
                              <Form.Item
                                name="planning_quantity"
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                  {
                                    pattern: new RegExp(/^\d+(\.\d+)?$/),
                                    message:
                                      "This value should be a non-zero positive value",
                                  },
                                  {
                                    pattern: new RegExp(
                                      /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                                    ),
                                    message:
                                      "Quantity should be a number greater than zero",
                                  },
                                ]}
                                className=""
                                initialValue={details?.planning_quantity}
                              >
                                <Input
                                  style={{ width: "332px" }}
                                  placeholder="Enter quantity"
                                  // onChange={(e) => {
                                  //   onPlanningQuantityValueChange(e);
                                  // }}
                                  disabled={true}
                                />
                              </Form.Item>
                              {/* {planningWtErr ? (
                                <div
                                  className="errorText"
                                  style={{
                                    color: "#ea4e2c",
                                    marginTop: "-17px",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Quantity to be planned cannot be more than the
                                  pending quantity
                                </div>
                              ) : null} */}
                            </div>
                          </>
                        )}
                      </div>

                      <div
                        className="drawerField"
                        style={{
                          borderBottom: "0px solid #edebe9",
                          marginLeft: "-12px",
                        }}
                      >
                        <div className="titleWithText">
                          <h5>Rewinder Details</h5>
                          <p>
                            The outer diameter of the reel and rewinder core
                          </p>
                        </div>

                        <div className="titleWithText">
                          <p style={{ marginLeft: "3px", marginBottom: "4px" }}>
                            Core OD
                          </p>
                        </div>
                        <Form.Item
                          name="core_OD"
                          rules={[]}
                          className="selectForm"
                          initialValue={details?.inner_dia}
                        >
                          {" "}
                          <Input
                            style={{ width: "332px" }}
                            placeholder={details?.inner_dia}
                            // onChange={(e) => {
                            //   onPlanningQuantityValueChange(e);
                            // }}
                            disabled={true}
                          />
                          {/* <Select
                            placeholder="Select Core OD"
                            suffixIcon={<DownArrowDraw />}
                            showSearch
                            optionFilterProp="children"
                            // onChange={handleCoreOD}
                            style={{ width: "331px" }}
                            disabled={true}
                          >
                          
                          </Select> */}
                        </Form.Item>
                        {/* {selectedReelOD?.length == 1 &&
                          coreOdValidationError ? (
                            <div
                              className="errorText"
                              style={{
                                color: "#ea4e2c",
                                marginLeft: "2px",
                                marginTop: "-22px",
                                marginBottom: "20px",
                              }}
                            >
                              Reel OD cannot be less than Core OD
                            </div>
                          ) : null} */}
                        <div
                          className=" switchRadio twoSwitch"
                          style={{
                            justifyContent: "center",
                            display: "flex",
                            marginRight: "-8px",
                          }}
                        >
                          <Radio.Group
                            options={rewinderType}
                            optionType="button"
                            buttonStyle="solid"
                            value={outerDiameter}
                            disabled={true}
                            // onChange={handleRewinderType}
                          />
                        </div>
                        {outerDiameter === "constant" ? (
                          selectedType == "reel" && orderQuantity == "reel" ? (
                            <div className="titleWithText">
                              <p
                                style={{
                                  marginLeft: "3px",
                                  marginBottom: "4px",
                                  marginTop: "22px",
                                }}
                              >
                                Reel OD
                              </p>
                              <Form.Item
                                name="reel_OD"
                                rules={[]}
                                className="selectForm"
                              >
                                <Select
                                  placeholder="Select Reel OD"
                                  suffixIcon={<DownArrowDraw />}
                                  showSearch
                                  optionFilterProp="children"
                                  // onChange={handleReelOD}
                                  style={{ width: "331px" }}
                                  disabled={true}
                                >
                                  {reelValues?.map((data) => (
                                    <Option key={data.value}>
                                      {data.value}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </div>
                          ) : (
                            <div>
                              <p
                                style={{
                                  marginLeft: "3px",
                                  marginBottom: "4px",
                                  marginTop: "15px",
                                }}
                              >
                                Reel OD
                              </p>
                              <Col className="blockBreak">
                                <div className="boxFormType">
                                  <PaperMachineQualitySelect>
                                    <MultiSelectCard>
                                      <Multiselect
                                        className="multiQuality"
                                        options={reelValues}
                                        style={multiselectStyle}
                                        showArrow={true}
                                        selectedValues={selectedReelOD}
                                        displayValue={"value"}
                                        showCheckbox={true}
                                        disable={true}
                                        // onSelect={onChangeReelOdSelect}
                                        // onRemove={onChangeReelOdSelect}
                                        hideSelectedList
                                        keepSearchTerm
                                      />
                                    </MultiSelectCard>
                                  </PaperMachineQualitySelect>
                                </div>

                                <Col span={12}>
                                  <PaperMachineGradeSelect>
                                    <div className="mainMachineGrade">
                                      {selectedReelOD &&
                                        selectedReelOD?.map((item, index) => {
                                          return (
                                            index <= 10 && (
                                              <span
                                                className={
                                                  "MachineGradeSelect-active"
                                                }
                                              >
                                                {/* {console.log(selectedReelOD)} */}
                                                {item.value}
                                                <Button
                                                  className="textTypeBtn textBtnIcon paperButtonBg"
                                                  // onClick={() => {
                                                  //   removeReelOD(item);
                                                  // }}
                                                  disabled={true}
                                                >
                                                  <Iconmoon
                                                    icon="wrong"
                                                    size={14}
                                                    color="#EA655B"
                                                  />
                                                </Button>
                                              </span>
                                            )
                                          );
                                        })}
                                    </div>
                                    {selectedReelOD &&
                                      selectedReelOD?.length > 10 &&
                                      selectedReelOD?.map((item, index) => {
                                        let tooltipData = "";
                                        for (
                                          let index = 10;
                                          index < selectedReelOD?.length;
                                          index++
                                        ) {
                                          const data = selectedReelOD[index];
                                          tooltipData =
                                            tooltipData + data.value + ", ";
                                        }
                                        tooltipData = tooltipData.substring(
                                          0,
                                          tooltipData.length - 1
                                        );
                                        return (
                                          index == 11 && (
                                            <Tooltip title={tooltipData}>
                                              {" "}
                                              <span
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "flex-end",
                                                }}
                                              >
                                                & {selectedReelOD.length - 10}{" "}
                                                More
                                              </span>
                                            </Tooltip>
                                          )
                                        );
                                      })}
                                  </PaperMachineGradeSelect>
                                </Col>
                              </Col>
                            </div>
                          )
                        ) : (
                          <div style={{ marginTop: "20px" }}>
                            <Col span={24}>
                              <Row className="centerAlign justifyCSBetween">
                                <Col span={8} className="blockBreak">
                                  <div
                                    className="boxFormType"
                                    style={{ marginBottom: "0" }}
                                  >
                                    <Form.Item
                                      label="Min Reel OD"
                                      name="min_reel_od"
                                      rules={[
                                        {
                                          pattern: new RegExp(
                                            /^\d+(\.\d{0,3})?$/
                                          ),
                                          message:
                                            "Only Numeric value is possible upto 3 decimal point",
                                        },
                                      ]}
                                      className="dBlock"
                                      initialValue={details?.minimum_reel_od}
                                    >
                                      <Input
                                        placeholder="Min Reel OD"
                                        className={
                                          reelODValidationError
                                            ? "showErrorBorder"
                                            : ""
                                        }
                                        // onChange={(e) => {
                                        //   onMinReelODChange(e);
                                        // }}
                                        disabled={true}
                                      />
                                    </Form.Item>
                                  </div>
                                </Col>
                                <Col span={8} className="blockBreak">
                                  <div
                                    className="boxFormType"
                                    style={{ marginBottom: "0" }}
                                  >
                                    <Form.Item
                                      label="Max Reel OD"
                                      name="max_reel_od"
                                      rules={[
                                        {
                                          pattern: new RegExp(
                                            /^\d+(\.\d{0,3})?$/
                                          ),
                                          message:
                                            "Only Numeric value is possible upto 3 decimal point",
                                        },
                                      ]}
                                      className="dBlock"
                                      initialValue={details?.maximum_reel_od}
                                    >
                                      <Input
                                        placeholder="Max Reel OD"
                                        className={
                                          reelODValidationError
                                            ? "showErrorBorder"
                                            : ""
                                        }
                                        disabled={true}

                                        // onChange={(e) => {
                                        //   onMaxReelODChange(e);
                                        // }}
                                      />
                                    </Form.Item>
                                  </div>
                                </Col>
                                <Col span={7} className="blockBreak">
                                  <div className="boxFormType unitSelect">
                                    <Form.Item
                                      label="Unit"
                                      name="reelOD_unit"
                                      rules={[]}
                                      className="dBlock"
                                      style={{ width: "100px" }}
                                      initialValue={
                                        details?.units?.minimum_reel_od
                                      }
                                    >
                                      <Select
                                        placeholder="Unit"
                                        suffixIcon={<DownArrowDraw />}
                                        className="dBlock"
                                        disabled={true}
                                      >
                                        {measurementData?.data.units_management.length.data?.map(
                                          (reelUnit) => (
                                            <Option
                                              key={reelUnit}
                                              value={reelUnit}
                                            >
                                              {
                                                lengthUnit[reelUnit]
                                                  ?.displayName
                                              }
                                            </Option>
                                          )
                                        )}
                                      </Select>
                                    </Form.Item>
                                  </div>
                                </Col>
                                {/* {reelODValidationError ? (
                                  <span
                                    className="errorText"
                                    style={{
                                      color: "#ea4e2c",
                                      marginTop: "-2px",
                                    }}
                                  >
                                    Max dia cannot be less than Min dia
                                  </span>
                                ) : null} */}
                              </Row>
                            </Col>
                          </div>
                        )}

                        {((selectedReelOD && selectedReelOD?.length == 1) ||
                          (reelOD &&
                            orderQuantity == "reel" &&
                            selectedType == "reel")) &&
                        outerDiameter !== "range" ? (
                          <div>
                            {orderQuantity != "reel" &&
                              selectedType != "reel" && (
                                <div className="titleWithText">
                                  <h5
                                    style={{
                                      color: "#ea655b",
                                      marginTop: "10px",
                                    }}
                                  >
                                    Calculated number of reels on specified Core{" "}
                                  </h5>
                                  <h5
                                    style={{
                                      color: "#ea655b",
                                      marginTop: "5px",
                                    }}
                                  >
                                    OD & Reel OD: {plannedReels}
                                  </h5>
                                </div>
                              )}
                            <Row className="centerAlign justifyCSBetween">
                              <Col span={10}>
                                <div className="boxFormType">
                                  <p
                                    style={{
                                      marginBottom: "3px",
                                      marginTop: "12px",
                                    }}
                                  >
                                    Rewinder Reels
                                  </p>
                                  <Form.Item
                                    name="no_of_reel_sheet"
                                    rules={[
                                      {
                                        pattern: new RegExp(
                                          /^\d+(\.\d{0,3})?$/
                                        ),
                                        message:
                                          "Only numeric characters upto 3 decimal points are allowed",
                                      },
                                    ]}
                                    className="dBlock"
                                    initialValue={details?.rewinder_reels}
                                  >
                                    <Input
                                      placeholder={details?.rewinder_reels}
                                      // onChange={(e) => {
                                      //   onPlannedReelsChange(e);
                                      // }}
                                      // value={}
                                      disabled={true}
                                    />
                                  </Form.Item>
                                </div>
                              </Col>
                              <Col span={13}>
                                <div className="boxFormType">
                                  <p
                                    style={{
                                      marginBottom: "3px",
                                      marginTop: "12px",
                                    }}
                                  >
                                    Planned Weight
                                  </p>

                                  <Input
                                    style={{ width: "185px" }}
                                    value={inputValue}
                                    disabled
                                  />

                                  <div
                                    style={{
                                      marginTop: "-30px",
                                      // marginLeft: "165px",
                                      position: "absolute",
                                      fontFamily: "var(--sf-pro-text)",
                                      color: "#a19f9d",
                                        width: "70px",
                                        right: 0,
                                      textAlign:'right'
                                    }}
                                  >
                                    {weightUnit[
                                      unitPlaceholder
                                    ]?.displayName?.toUpperCase()}
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        ) : null}
                      </div>
                    </Panel>
                  </Collapse>
                </div>

                {/* rewinder dimentions */}
                {/* <div className="drawerField removeStar">
                  <div className="titleWithText">
                    <h5>Rewinder Details</h5>
                    <p>The outer diameter of the reel and rewinder core</p>
                  </div>
                  <Col span={24}>
                    <Row className="centerAlign justifyCSBetween">
                      <Col>
                        <Checkbox checked={rewinderDia} disabled></Checkbox>
                        <span
                          style={{
                            marginLeft: "5px",
                            fontSize: "12px",
                            fontWeight: "500",
                            fontSize: "12px",
                            fontFamily: "var(--sf-pro-text)",
                            color: "var(--color-text-title)",
                            lineHeight: "20px",
                          }}
                        >
                          Allow multiple rewinder dia in production
                        </span>
                      </Col>
                    </Row>
                    <Row className="centerAlign  justifyCSBetween">
                      <Col span={8} className="blockBreak">
                        <div
                          className="boxFormType"
                          style={{ marginBottom: "0" }}
                        >
                          <Form.Item
                            // label="Core OD"
                            name="Core OD"
                            rules={[{ required: true }]}
                            initialValue={details.core_od}
                            className="dBlock"
                            style={{ marginBottom: "0px" }}
                          >
                            <Input placeholder="For Core OD" disabled />
                          </Form.Item>{" "}
                          <p>Core ID</p>
                        </div>
                      </Col>
                      <Col span={8} className="blockBreak">
                        <div className="boxFormType">
                          <Form.Item
                            // label="Reel OD"
                            name="Reel OD"
                            rules={[{ required: true }]}
                            initialValue={details.reel_od}
                            className="dBlock"
                            style={{ marginBottom: "0px" }}
                          >
                            <Input placeholder="For Reel OD" disabled />
                          </Form.Item>{" "}
                          <p>Reel OD</p>
                        </div>
                      </Col>
                      <Col span={7} className="blockBreak">
             
                        <div className="boxFormType unitSelect">
                          <Form.Item
                            // label="Reels Unit"
                            name="Unit"
                            rules={[{ required: true }]}
                            // initialValue={details?.unit}
                            initialValue={details.units.core_id}
                            className="dBlock"
                            style={{ marginBottom: "0px" }}
                          >
                            <Select
                              label="Unit"
                              placeholder="Unit"
                              disabled
                              suffixIcon={<DownArrowDraw />}
                              className="dBlock"
                            >
                              {deckleWidthUnitData.map((deckleWidth) => (
                                <Option
                                  key={deckleWidth.value}
                                  value={deckleWidth.value}
                                >
                                  {deckleWidth}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                          <p>Reels Unit</p>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div> */}
                {/* planned number of rewinder reels */}
                {/* {((orderDetails?.type === "sheet" &&
                  orderDetails?.core_id &&
                  orderDetails?.reel_od) ||
                  orderDetails?.type === "reel") && (
                  <div className="drawerField">
                    <div className="titleWithText">
                      <h5>Planned Number of Rewinder Reels</h5>
                      <p>
                        The number of rewinder reels required to fulfill the
                        order
                      </p>
                    </div>
                    <Form.Item
                      name="no_of_reel_sheet"
                      rules={[
                        {
                          required: true,
                        },
                        {
                          pattern: new RegExp(/^[0-9]+$/),
                          message: "Only Numeric value is possible",
                        },
                      ]}
                      className=""
                      initialValue={details.quantity} //quantity
                    >
                      <Input placeholder="Enter the number of reels" disabled />
                    </Form.Item>
                  </div>
                )} */}
                {/* planned weight  */}
                {/* <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Planned Weight</h5>
                    <p>
                      Calculated weight of order for planned number of reels
                    </p>
                  </div>
                  <div style={{ position: "relative" }}>
                    <Form.Item
                      name="planned_weight"
                      rules={[]}
                      className=""
                      initialValue={details.plannedWeight}
                    >
                      <Input disabled />
                    </Form.Item>
                    <span className="nonEditable">
                      {weightUnit[details.units.planned_weight]?.displayName}
                    </span>
                  </div>
                  {orderDetails?.type === "sheet" &&
                    !orderDetails?.core_id &&
                    !orderDetails?.reel_od && (
                      <Collapse
                        onChange={onChangeCollpase}
                        expandIconPosition="right"
                        bordered={false}
                        style={{ backgroundColor: "white", marginTop: "-18px" }}
                      >
                        <Panel
                          header={
                            "Tolerance -" +
                            details?.upper_tolerance +
                            " to +" +
                            details?.lower_tolerance +
                            " %"
                          }
                          style={{ fontStyle: "italic", marginLeft: "-12px" }}
                        >
                          <Row
                            style={{ marginTop: "3px" }}
                            className="centerAlign  justifyCSBetween"
                          >
                            <Col span={8} className="blockBreak">
                              <div className="titleWithText">
                                <p
                                  style={{
                                    marginTop: "7px",
                                    fontStyle: "initial",
                                    fontSize: "12px",
                                    fontFamily: "var(--sf-pro-text)",
                                    color: "var(--color-text-title)",
                                    lineHeight: "20px",
                                  }}
                                >
                                  Upper Tolerance{" "}
                                </p>
                              </div>
                            </Col>
                            <Col span={8} className="blockBreak">
                              <div
                                className="boxFormType"
                                style={{ marginBottom: "0" }}
                              >
                                <Form.Item
                                  label=""
                                  name="upper_tolerance"
                                  rules={[
                                    {
                                      pattern: new RegExp(/^\d+(\.\d{0,5})?$/),
                                      message: "Only Numeric value is possible",
                                    },
                                    {
                                      required: true,
                                      message: "This field is required",
                                    },
                                  ]}
                                  className="dBlock"
                                  initialValue={details?.upper_tolerance}
                                >
                                  <Input
                                    placeholder=""
                                    style={{ fontSize: "10px", height: "30px" }}
                                    disabled
                                  />
                                </Form.Item>
                                <span
                                  className="nonEditable"
                                  style={{ fontize: "13px", top: "5px" }}
                                >
                                  %
                                </span>
                              </div>
                            </Col>
                            <Col span={8} className="blockBreak">
                              <Col
                                span={8}
                                className="blockBreak"
                                style={{ maxWidth: "45%", marginLeft: "15px" }}
                              >
                                <div className="titleWithText">
                                  <p
                                    style={{
                                      fontSize: "12px",
                                      fontFamily: "var(--sf-pro-text)",
                                      color: "var(--color-text-title)",
                                      lineHeight: "20px",
                                      marginTop: "7px",
                                      fontStyle: "initial",
                                      width: "104px",
                                    }}
                                  >
                                    {details?.calculated_upper_tolerance + " "}{" "}
                                    {
                                      weightUnit[
                                        details.units.calculated_upper_tolerance
                                      ]?.displayName
                                    }
                                  </p>
                                </div>
                              </Col>
                            </Col>
                          </Row>

                          <Row
                            style={{ marginTop: "0px" }}
                            className="centerAlign  justifyCSBetween"
                          >
                            <Col span={8} className="blockBreak">
                              <div className="titleWithText">
                                <p
                                  style={{
                                    marginTop: "7px",
                                    fontStyle: "initial",
                                    fontSize: "12px",
                                    fontFamily: "var(--sf-pro-text)",
                                    color: "var(--color-text-title)",
                                    lineHeight: "20px",
                                  }}
                                >
                                  Lower Tolerance{" "}
                                </p>
                              </div>
                            </Col>
                            <Col span={8} className="blockBreak">
                              <div
                                className="boxFormType"
                                style={{ marginBottom: "0" }}
                              >
                                <Form.Item
                                  label=""
                                  name="lower_tolerance"
                                  rules={[
                                    {
                                      pattern: new RegExp(/^\d+(\.\d{0,5})?$/),
                                      message: "Only Numeric value is possible",
                                    },
                                    {
                                      required: true,
                                      message: "This field is required",
                                    },
                                  ]}
                                  className="dBlock"
                                  initialValue={details?.lower_tolerance}
                                >
                                  <Input
                                    placeholder=""
                                    style={{ fontSize: "10px", height: "30px" }}
                                    disabled
                                  />
                                </Form.Item>
                                <span
                                  className="nonEditable"
                                  style={{ fontize: "13px", top: "5px" }}
                                >
                                  %
                                </span>
                              </div>
                            </Col>
                            <Col span={8} className="blockBreak">
                              <Col
                                span={8}
                                className="blockBreak"
                                style={{ maxWidth: "45%", marginLeft: "15px" }}
                              >
                                <div className="titleWithText">
                                  <p
                                    style={{
                                      fontSize: "12px",
                                      fontFamily: "var(--sf-pro-text)",
                                      color: "var(--color-text-title)",
                                      lineHeight: "20px",
                                      marginTop: "7px",
                                      fontStyle: "initial",
                                      width: "104px",
                                    }}
                                  >
                                    {details?.calculated_lower_tolerance + " "}{" "}
                                    {
                                      weightUnit[
                                        details.units.calculated_lower_tolerance
                                      ]?.displayName
                                    }
                                  </p>
                                </div>
                              </Col>
                            </Col>
                          </Row>
                        </Panel>
                      </Collapse>
                    )}
                </div> */}
                {/* {props.showButton && (
                  <div className="buttonFlex fixedBtm">
                    <Form.Item>
                      <Button htmlType="submit" className="themeBtn">
                        <Iconmoon icon="export" size={16} color="#ffffff" /> Go
                        to PO page{" "}
                      </Button>
                    </Form.Item>
                  </div>
                )} */}
              </Form>
            </HaberForm>
          </DetailFields>
        </div>
      </RightDrawerContainer>
    </RightDrawerSidebar>
  ) : null;
};

export default ViewDeckleOrder; 
